import { render, staticRenderFns } from "./centerUpload.vue?vue&type=template&id=189e8775&scoped=true&"
import script from "./centerUpload.vue?vue&type=script&lang=js&"
export * from "./centerUpload.vue?vue&type=script&lang=js&"
import style0 from "./centerUpload.vue?vue&type=style&index=0&id=189e8775&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189e8775",
  null
  
)

export default component.exports